<template lang="html">
  <div class="governments-container flex spaced column">
    <div class="top-img">
      <div class="overlay overblue"></div>
      <img src="../assets/images/gov/govpage_main.png" alt="">
    </div>
    <div class="content-top text-white row">
      <div class="page-title--norm content-padded">
        We enable Governments <br class="desktop-only">stay competitive in the global <br class="desktop-only">economy by transforming <br class="desktop-only">payment collection
      </div>
      <div class="flex wrap content-slim--desktop">
        <div class="content-padded content-mintext equal-width">
          Governments can spur thriving economies by offering convenient access to public services and utilities.
        </div>
        <div class="content-padded content-mintext equal-width">
          Pesaflow works with governments to offer suitable payment solutions that enhance service delivery.
        </div>
      </div>
    </div>
    <div class="dark-blue text-white row flex column wrap">
      <div class="content-padded content-maintext flex column equal-width">
        Pesaflow is for governments seeking to improve operating efficiency.
      </div>
      <div class="content-padded content-subtext work-text  equal-width">
        With our proven and secure platform for disbursing and receiving payments, Governments can simplify settlements and provide better service.
      </div>
    </div>
    <div class="row content-spaced text-blue white">
      <div class="content-margin">
        <div class="content-maintext content-padded">
          For smart Public Finance management, Pesaflow offers:
        </div>
        <div class="wrap flex">
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Better settlements management
            </div>
            <div class="content-subtext content-padded">
              Our fully digital and automated solution means less paperwork. Say goodbye to missing receipts and expense reporting guesswork.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Payment <br class="desktop-only">Transparency
            </div>
            <div class="content-subtext content-padded">
              With visibility into settlements as they happen in realtime and automated reconciliations, Pesaflow creates clear trails and records.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Improved <br class="desktop-only">invoicing
            </div>
            <div class="content-subtext content-padded">
              Pesaflow enables fully digital and simplified invoicing.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Enhanced <br class="desktop-only">efficiency
            </div>
            <div class="content-subtext content-padded">
              By coupling payment details with the transaction, real-time payments help improve efficiency, customer engagement, data transparency and accuracy.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Realtime dashboards <br class="desktop-only">and analytics
            </div>
            <div class="content-subtext content-padded">
              Pesaflow offers dashboards that give instant statistics on revenue streams, while providing details on users, transactions, and services issued, all in real-time.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-subtitle content-padded container top-rule">
              Full customisation and <br class="desktop-only">dynamic integrations
            </div>
            <div class="content-subtext content-padded">
              In the absence of any system set up or with existing technology, Pesaflow’s custom payments collection engine can be configured and plugged in as a payment aggregator.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img">
        <div class="overlay dark-blue"></div>
        <img src="../assets/images/gov/govpage_1.png" alt="">
      </div>
      <div class="row text-white container content-margin">
        <div class="content-padded content-subtitle">
          The Technology
        </div>
        <div class="content-maintext content-padded">
          Fast evolving technology and increasing volumes of data present new challenges for governments. Pesaflow is equipped to perform at scale.
        </div>
        <div class="wrap flex">
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/gov/govpage_2.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Machine learning
            </div>
            <div class="content-padded content-subtext">
              Powered by machine learning, Pesaflow provides an intelligent financial system that can learn user trends and offer insights for improving service delivery.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/gov/govpage_3.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Big data
            </div>
            <div class="content-padded content-subtext">
              In an increasingly digital world, staggering volumes of data are generated. Pesaflow ensures a high level of data quality and accessibility for intelligence and big data analytics applications while guaranteeing interoperability and data security.
            </div>
          </div>
          <div class="flex third-width column">
            <div class="content-padded">
              <img src="../assets/images/gov/govpage_4.svg" alt="" class="stats-img">
            </div>
            <div class="content-subtitle content-padded">
              Distributed system
            </div>
            <div class="content-padded content-subtext">
              Pesaflow is built to leverage horizontal scaling, taking advantage of cloud infrastructure or large clustered data centres. This allows it to handle exponential growth in user base.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="back-img med-blue">
        <img src="../assets/images/home/homepage_7.png" alt="">
      </div>
      <div class="row content-margin flex wrap spaced container">
        <div class="content-padded content-maintext">
          Pesaflow’s technology <br class="desktop-only"/>enables governments to <br class="desktop-only"/>do more.
        </div>
        <div class="content-padded vertical-center flex">
          <button type="button" name="button" class="dark-blue text-white talk-btn">Talk to us today</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint max-len :0 */
export default {
  name: 'Governments',
};
</script>

<style lang="css" scoped>
.content-top {
  min-height: 81vh;
}
@media only screen and (min-width: 1024px) {
  .content-top {
    min-height: 68vh;
  }
  .content-padded.top-rule:before {
    top: 5px;
  }
}
</style>
